module.exports = __webpack_public_path__ + "static/media/piotr-chojnacki.6493303d.jpg";